import Modal from "components/Modal";
import Transition from "components/Transition";
import TripDatesModal from "containers/TripDatesModal/TripDatesModal";
import { CartContext } from "contexts/cart/cart.context";
import { getCookie, setCookie } from "helper/session";
import moment from "moment-timezone";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useState } from "react";
import notifications from "utils/notifications";

const cats = [
  {
    name: "Camping",
    link: "/camping",
  },
  {
    name: "Hiking",
    link: "/hiking",
  },
  {
    name: "Travel",
    link: "/bike-bags-racks",
    items: [
      {
        name: "Rooftop Carriers",
        link: "/cargo-carriers-and-baskets",
      },
      {
        name: "Travel",
        link: "/bike-bags-racks",
      },
      {
        name: "Toddler Travel",
        link: "/toddler-travel",
      },
    ],
  },
];

export default function Sidebar() {
  const router = useRouter();
  const {
    cart: {
      orderStartTime,
      orderEndTime,
      tripDiscountMultiplier,
      tripDays,
      region,
      fulfillmentCenter,
    },
  } = useContext(CartContext);
  const [modalOpen, setModalOpen] = useState(null);
  const [isOpen, setIsOpen] = useState(null);

  useEffect(() => {
    if (tripDiscountMultiplier < 1) {
      if (!(getCookie("scdp") === tripDiscountMultiplier.toString())) {
        notifications.info(
          <>
            You qualify for a {((1 - tripDiscountMultiplier) * 100).toFixed(0)}%
            discount on all rental products for booking {tripDays} days!
          </>,
          `You've Received a Discount!!`,
          6000
        );
      }
    }
    setCookie("scdp", tripDiscountMultiplier.toString());
  }, [tripDiscountMultiplier]);

  function showDatesModal(position) {
    setModalOpen(
      <Modal
        open={true}
        fullscreen={true}
        onClose={() => setModalOpen(null)}
        content={
          <TripDatesModal
            onOk={() => setModalOpen(null)}
            position={position ?? "bottom"}
          />
        }
        contentClasses={"overflow-visible"}
      />
    );
  }

  function toggle() {
    setIsOpen(!isOpen);
  }

  return (
    <section className="md:w-72">
      {modalOpen}
      <div className="hidden md:block">
        <div
          className="mb-2 bg-scuttle-orange text-white rounded shadow p-4 cursor-pointer"
          onClick={showDatesModal}
        >
          <h2 className="px-3 text-xs leading-4 font-bold uppercase tracking-wider flex justify-between items-center">
            Rental Dates
            <span
              className="inline-flex text-white ml-2 cursor-pointer"
              onClick={showDatesModal}
            >
              <svg
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="pencil-alt w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </span>
          </h2>
          <div className="mt-2 ">
            {orderStartTime ? (
              <h3 className="px-3">{`${moment
                .tz(orderStartTime, "Africa/Johannesburg")
                .format("ddd DD MMM")} - ${moment
                .tz(orderEndTime, "Africa/Johannesburg")
                .format("ddd DD MMM")}`}</h3>
            ) : (
              <p className="px-3">Click here to select your dates</p>
            )}
          </div>
          {region && (
            <div className="px-3 mt-1 flex-col">
              <p className="text-sm font-semibold  text-white">{region}</p>
              <p className="text-xs font-semibold  text-white">
                Fulfilled from {fulfillmentCenter}
              </p>
            </div>
          )}
          {tripDiscountMultiplier < 1 && (
            <div className="px-3 mt-2 flex">
              <span className="inline-flex items-center px-3 py-0.5 rounded text-sm font-medium leading-5 bg-orange-100 text-orange-800">
                {((1 - tripDiscountMultiplier) * 100).toFixed(0)}% discount on
                rental items
              </span>
            </div>
          )}
        </div>
        <div className="bg-scuttle-blue text-white rounded shadow p-4 ">
          {/* <h3 className="leading-4 font-bold text-white uppercase tracking-wider">
                        <Link href={"/"} prefetch={false}>
                            <a
                                className="cursor-pointer group flex items-center px-3 py-2 text-sm leading-5 font-bold rounded-md border-2 border-scuttle-orange hover:bg-scuttle-orange focus:outline-none focus:font-bold focus:bg-scuttle-orange transition ease-in-out duration-150">
                                All Products
                            </a>
                        </Link>
                    </h3> */}

          <div className="mt-1 space-y-2" role="group">
            {cats.map(({ name, link }) => (
              <div key={name}>
                <Link key={name} href={link} prefetch={false}>
                  <a
                    className="group flex items-center px-3 py-2 text-sm leading-5 font-bold text-white rounded-md border-l-4 border-transparent
                                        hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition ease-in-out duration-150"
                  >
                    {name}
                  </a>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="md:hidden fixed z-500 w-full flex justify-between bg-scuttle-blue text-white shadow-lg">
        <div
          className="bg-scuttle-blue p-4 cursor-pointer"
          onClick={() => showDatesModal("top")}
        >
          <h2 className="flex items-center  px-3 text-xs leading-4 font-bold uppercase tracking-wider">
            Rental Dates
            <span className="inline-flex items-center text-scuttle-orange ml-2 cursor-pointer">
              <svg
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="pencil-alt w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </span>
          </h2>
          <div className="mt-2">
            {orderStartTime ? (
              <h3 className="px-3">{`${moment
                .tz(orderStartTime, "Africa/Johannesburg")
                .format("ddd DD MMM")} - ${moment
                .tz(orderEndTime, "Africa/Johannesburg")
                .format("ddd DD MMM")}`}</h3>
            ) : (
              <p className="px-3 text-sm">Click here to select your dates</p>
            )}
            {/*<h3 className="px-3 text-xs text-gray-700">{`${moment(orderStartTime).format('ddd DD MMM')} - ${moment(orderEndTime).format('ddd DD MMM')}`}</h3>*/}
          </div>
        </div>
        <div className="p-2 bg-scuttle-blue">
          <button
            type="button"
            className="p-2 h-full inline-flex items-center focus:outline-none rounded-lg shadow"
            onClick={toggle}
          >
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
              />
            </svg>
            <span className="ml-1 text-white font-medium">Categories</span>
          </button>
        </div>
      </div>

      <Transition
        show={isOpen}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 -translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-1"
        appear={true}
      >
        <div className="fixed inset-x-0 transform shadow-lg z-400">
          <div className="absolute inset-0 flex">
            <div className="bg-white w-1/2" />
            <div className="bg-gray-50 w-1/2" />
          </div>
          <div className="relative overflow-y-scroll scrolling-touch pt-24 relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2">
            <nav className="grid gap-y-10 px-4 py-8 bg-white sm:grid-cols-2 sm:gap-x-8 sm:py-12 sm:px-6 lg:px-8 xl:pr-12">
              {cats.map(({ name, link }) => (
                <div key={name}>
                  <div className="space-y-2">
                    <Link key={name} href={link} prefetch={false}>
                      <a className="ml-3 py-1 flex items-center space-x-4 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50 transition ease-in-out duration-150">
                        <h3 className="text-sm leading-5 font-medium tracking-wide text-gray-500 uppercase">
                          {name}
                        </h3>
                      </a>
                    </Link>
                  </div>
                </div>
              ))}
            </nav>
          </div>
        </div>
      </Transition>
    </section>
  );
}
